import type { HTMLAttributes } from "react";

export default function DownloadIcon(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 8.625V12.5625C13.125 12.7117 13.0657 12.8548 12.9602 12.9602C12.8548 13.0657 12.7117 13.125 12.5625 13.125H1.3125C1.16332 13.125 1.02024 13.0657 0.914753 12.9602C0.809263 12.8548 0.75 12.7117 0.75 12.5625V8.625M3.98438 5.67265L6.9375 8.625L9.89062 5.67265M6.9375 0.75V8.62293"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
